/* eslint-disable */
import React, { PropTypes } from 'react';
import moment from 'moment';
import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
// import { browserHistory } from 'react-router';
import NewsModalPs from './NewsModalPs'

import autoFill from '../../../commonJS/autoFill';

export default class NewsModalCt extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			aNewsId: '', //news_id
			enableEdit: false, //是否為編輯模式
			aNewsTitle_tw: '', //標題
			aNewsTitle_en: '', //標題
			aNewsTitle_cn: '', //標題
			aNewsTitle_ja: '', //標題
			aNewsFlag: 'normal', //置頂/重要/一般
			aNewsType_id: '1', //類型
			aNewsStart_time: moment().format('YYYY/MM/DD'), //開始時間
			aNewsEnd_time: moment().format('YYYY/MM/DD'), //結束時間
			aNewsMessage_tw: '', //內容
			aNewsMessage_en: '', //內容
			aNewsMessage_cn: '', //內容
			aNewsMessage_ja: '', //內容
			showErrorMsg: false, //是否顯示錯誤訊息
			newsTypeArray: [], //類型options
			filesToUpload: [], //要上傳的檔案
			aNewsImages: [], //附件:圖片
			aNewsPDFs: [], //附件:PDF
			aNewsVideos: [], //附件:影片
			fileUploading: false, //是否正在上傳中
			all_policy: '1',//瀏覽權限:all
			userOptions: [],//成員
			groupOptions: [],//部門
			groupSelectedValues: '',//已選擇的部門
			userSelectedValues: '',//已選擇的成員
			deleteFiles: []
		}

		this.handlers = {
			onInputFocus: e => {
				autoFill(e, this);
			}
		}

		this.onClickEdit = this.onClickEdit.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onChangeDate = this.onChangeDate.bind(this);
		this.sendEdit = this.sendEdit.bind(this);
		this.onClickDelete = this.onClickDelete.bind(this);
		this.onDrop = this.onDrop.bind(this);
		this.fileDelete = this.fileDelete.bind(this);
		this.multiSelectChangeHandler = this.multiSelectChangeHandler.bind(this);
		this.onPreviewFileDelete = this.onPreviewFileDelete.bind(this);
	}
	componentWillMount() {
		/*
			是不是在新增?
			1. 在: 一開始就是編輯模式
			2. 否: 預設的檢視模式
		*/

		const { route, params } = this.props

		if (route.type === 'add') {
			this.setState({ enableEdit: true })
		}
		else {
			this.loadMultiSelectOptions();
			this.loadOneNews(params.newsId);
		}

		// const { newsId } = this.props.params

		// let pathname = this.props.location.pathname;
		// if( pathname.includes('news/create') ){//新增
		//     this.setState({
		//         enableEdit: true,
		//     });
		// } else {//修改
		//   this.loadMultiSelectOptions();
		//   this.loadOneNews(newsId);
		// }
	}
	componentDidMount() {
		this.loadNewsType();//最新消息的類型
	}
	loadNewsType() {
		$.ajax({
			type: 'get',
			url: '/api/W_SaleSky_News_Type_Lang_Get.php',
			success: response => {
				if (response.status === '0') {
					const
						lang_code = window.myConsts.languageCode,
						// api 單用lang_code無法正常運作，只好全抓再篩選
						newsTypeArray = _.filter(response.result, { lang_code });

					this.setState({ newsTypeArray });
				}
			},
			error: (xhr, ajaxOptions, thrownError) => { }
		});
	}
	loadOneNews(id) {
		let aNewsId = id;

		// const aNewsId = this.props.params.newsId;
		// let news_id = aNewsId !== undefined ? aNewsId : this.state.aNewsId

		$.get(`/api/W_SaleSky_News_Lang_Get.php?news_id=${aNewsId}`, response => {
			// let aNewsObject = response.result[0];

			if (response.status !== '0') {
				alert(response.msg);
				return;
			}

			let aNewsObject = response.result, userSelectedValues = '';

			for (let i = 0; i < aNewsObject.user_id_name_list.length; i++) {
				userSelectedValues += aNewsObject.user_id_name_list[i].user_id + ',';
			}
			userSelectedValues = userSelectedValues.substring(0, (userSelectedValues.length - 1));
			let groupSelectedValues = '';
			for (let i = 0; i < aNewsObject.group_id_name_list.length; i++) {
				groupSelectedValues += aNewsObject.group_id_name_list[i].group_id + ',';
			}
			groupSelectedValues = groupSelectedValues.substring(0, (groupSelectedValues.length - 1));

			this.setState({
				aNewsId: aNewsObject.id,
				aNewsTitle_tw: aNewsObject.title_list.title_tw,
				aNewsTitle_en: aNewsObject.title_list.title_en,
				aNewsTitle_cn: aNewsObject.title_list.title_cn,
				aNewsTitle_ja: aNewsObject.title_list.title_ja,
				aNewsFlag: aNewsObject.flag,
				aNewsType_id: aNewsObject.type_id,
				aNewsStart_time: moment(aNewsObject.start_time).format('YYYY/MM/DD'),
				aNewsEnd_time: moment(aNewsObject.end_time).format('YYYY/MM/DD'),
				aNewsMessage_tw: aNewsObject.message_list.message_tw,
				aNewsMessage_en: aNewsObject.message_list.message_en,
				aNewsMessage_cn: aNewsObject.message_list.message_cn,
				aNewsMessage_ja: aNewsObject.message_list.message_ja,
				aNewsImages: aNewsObject.images,
				aNewsPDFs: aNewsObject.pdfs,
				aNewsVideos: aNewsObject.videos,
				all_policy: aNewsObject.all_policy,
				userSelectedValues: userSelectedValues,
				groupSelectedValues: groupSelectedValues
			});
		}).fail(error => { });

		// if ( aNewsId !== undefined ) {//params有newsId, 代表在修改頁面
		//     $.get('/api/W_SaleSky_News_Get.php?news_id='+ aNewsId, response => {
		//         let aNewsObject = response.result[0];
		//         this.setState({
		//             aNewsId: aNewsObject.id,
		//             aNewsTitle: aNewsObject.title,
		//             aNewsFlag: aNewsObject.flag,
		//             aNewsType_id: aNewsObject.type_id,
		//             aNewsStart_time: moment(aNewsObject.start_time).format('YYYY/MM/DD'),
		//             aNewsEnd_time: moment(aNewsObject.end_time).format('YYYY/MM/DD'),
		//             aNewsMessage: aNewsObject.message,
		//             aNewsImages: aNewsObject.images,
		//             aNewsPDFs: aNewsObject.pdfs,
		//             aNewsVideos: aNewsObject.videos,
		//         });
		//     }).fail(error=> {});

		// } else {
		//      //這個if在新增完一筆News之後(sendEdit)才會進來, 目的是取得新增成功的response.result[0].id後, 使用者可以繼續update
		//      let aNewsId = this.state.aNewsId;
		//      $.get('/api/W_SaleSky_News_Get.php?news_id='+aNewsId, response => {
		//          let aNewsObject = response.result[0];
		//          this.setState({
		//             aNewsId: aNewsObject.id, //新增成功後要有id才能繼續update
		//             aNewsTitle: aNewsObject.title,
		//             aNewsFlag: aNewsObject.flag,
		//             aNewsType_id: aNewsObject.type_id,
		//             aNewsStart_time: moment(aNewsObject.start_time).format('YYYY/MM/DD'),
		//             aNewsEnd_time: moment(aNewsObject.end_time).format('YYYY/MM/DD'),
		//             aNewsMessage: aNewsObject.message,
		//             aNewsImages: aNewsObject.images,
		//             aNewsPDFs: aNewsObject.pdfs,
		//             aNewsVideos: aNewsObject.videos,
		//         });
		//      })
		// }
	}
	onDrop(filesToUpload) {
		this.setState({
			filesToUpload: filesToUpload,
		});
	}
	onPreviewFileDelete(file_name) {

		const { filesToUpload } = this.state

		let files = _.pullAllBy(filesToUpload, [{ 'name': file_name }], 'name')
		this.setState({ filesToUpload: files })
	}
	onClickEdit() {
		//點選右上角的'編輯',進入編輯模式
		this.setState({
			enableEdit: true,
		});
	}
	onChangeHandler(stateName, event) {
		/*
			stateName: 要修改的state
		*/
		let newState = {};
		newState[stateName] = event.target.value;
		this.setState(newState);
		// if( stateName === 'all_policy' ) this.showMultiSelectField(event.target.value);
		if (stateName === 'all_policy') this.loadMultiSelectOptions();
	}
	onChangeDate(type, date) {
		/*
			type: 開始or結束
			date: 修改的日期時間
		*/
		let newState = {};
		newState[type] = date.format('YYYY/MM/DD');
		this.setState(newState);
	}
	sendEdit(event) {
		// 畫面上只顯示繁體中文欄位
		// let title = `${this.state.aNewsTitle_tw}|${this.state.aNewsTitle_en}|${this.state.aNewsTitle_cn}|${this.state.aNewsTitle_ja}`;
		let title = `${this.state.aNewsTitle_tw}|${this.state.aNewsTitle_tw}|${this.state.aNewsTitle_tw}|${this.state.aNewsTitle_tw}`,
			flag = this.state.aNewsFlag,
			type_id = this.state.aNewsType_id,
			start_time = moment(new Date(this.state.aNewsStart_time)).format('YYYY-MM-DD HH:mm'),
			end_time = moment(new Date(this.state.aNewsEnd_time)).format('YYYY-MM-DD HH:mm'),
			// message = `${this.state.aNewsMessage_tw}|${this.state.aNewsMessage_en}|${this.state.aNewsMessage_cn}|${this.state.aNewsMessage_ja}`,
			message = `${this.state.aNewsMessage_tw}|${this.state.aNewsMessage_tw}|${this.state.aNewsMessage_tw}|${this.state.aNewsMessage_tw}`,
			id = this.state.aNewsId,
			filesToUpload = this.state.filesToUpload,
			hasNotCreate = this.state.aNewsId === ''; //如果aNewsId是'',代表這是要新增的news(create)

		const { all_policy, userSelectedValues, groupSelectedValues, deleteFiles } = this.state;

		// if(filesToUpload.length!==0) this.fileUploadPost(filesToUpload); //若filesToUpload有檔案,則進入fileUploadPost

		// 因為畫面上只有顯示繁體中文欄位，所以檢查只檢查繁體中文
		// if (this.state.aNewsTitle_tw === '' || this.state.aNewsTitle_en === '' || this.state.aNewsTitle_cn === '' || this.state.aNewsTitle_ja === '') {
		// 	title = '';
		// }
		// if (this.state.aNewsMessage_tw === '' || this.state.aNewsMessage_en === '' || this.state.aNewsMessage_cn === '' || this.state.aNewsMessage_ja === '') {
		// 	message = '';
		// }
		if (this.state.aNewsTitle_tw === '') title = '';
		if (this.state.aNewsMessage_tw === '') message = '';

		if (title !== '' && flag !== '' && start_time !== '' && end_time !== '' && message !== '' && (all_policy === '1' || userSelectedValues.length || groupSelectedValues.length)) {
			let formData = new FormData();
			formData.append('title_list', title); //標題
			formData.append('flag', flag); //置頂/重要/一般
			formData.append('type_id', type_id); //分類
			formData.append('start_time', start_time);
			formData.append('end_time', end_time);
			formData.append('message_list', message); //內容
			formData.append('all_policy', all_policy); //內容
			formData.append('user_id_list', userSelectedValues); //內容
			formData.append('group_id_list', groupSelectedValues); //內容

			if (!hasNotCreate) formData.append('news_id', id); //如果有aNewsId, 代表是要update的news, 需要加上id

			$.ajax({
				type: 'post',
				url: `/api/W_SaleSky_News_Lang_${hasNotCreate ? 'Post' : 'Update'}.php`,
				data: formData,
				processData: false,
				contentType: false,
				success: response => {
					if (response.status === '0') {//成功
						if (filesToUpload.length !== 0) this.fileUploadPost(response.result.id); //若filesToUpload有檔案,則進入fileUploadPost
						if (deleteFiles.length > 0) this.removeFiles();
						// browserHistory.push('/salesky/news/' + response.result[0].id)
						this.props.reloadDataList();//newsDataTable也要重刷頁面
						this.setState({ enableEdit: false, filesToUpload: [] })
						this.loadOneNews(response.result.id);//重刷頁面
						// this.setState({
						//     aNewsId: response.result[0].id,//新增一筆News後 若要繼續編輯, 則要在新增成功的response取得新增的news_id
						//     enableEdit: false,//換成檢視模式
						//     filesToUpload: [],//清空上傳檔案的區塊
						// });
					} else {
						alert(response.msg);
					}
				},
				error: error => { },
				// complete: ()=> {
				//     this.loadOneNews();//重刷頁面
				//     this.props.reloadDataList();//newsDataTable也要重刷頁面
				// },
			});

		} else {
			this.setState({
				showErrorMsg: true,
			});
		}
	}
	fileUploadPost(id) {

		const { filesToUpload } = this.state

		let type = 'News';
		let file_id = id;

		for (let i = 0; i < filesToUpload.length; i++) {
			let formData = new FormData();
			formData.append('file', filesToUpload[i]);
			formData.append('file_id', file_id); //file_id為這則news的id
			formData.append('type', type); //最新消息的type固定是'News'

			$.ajax({
				async: false,
				type: 'post',
				url: '/api/W_SaleSky_FileUpload_Post.php',
				data: formData,
				processData: false,
				contentType: false,
				success: response => { },
				error: error => { },
				beforeSend: () => {
					this.setState({
						fileUploading: true,
					});
				},
				complete: () => {
					this.setState({
						fileUploading: false,//顯示檔案上傳中的圖示
					});
					//this.loadOneNews();
				},
			});
		}
	}
	fileDelete(event, file_name, type) {
		/*
			event: 這好像是不需要的...
			file_name: http://dev.sky-family.net/corp_2015082401/News/5/201702181504133927.png
		*/
		const { aNewsImages, aNewsPDFs, aNewsVideos, deleteFiles } = this.state

		switch (type) {

			case 'img':
				let imgs = _.pullAllBy(aNewsImages, [{ 'file_name': file_name }], 'file_name')
				this.setState({ aNewsImages: imgs, })
				break;
			case 'pdf':
				let pdfs = _.pullAllBy(aNewsPDFs, [{ 'file_name': file_name }], 'file_name')
				this.setState({ aNewsPDFs: pdfs, })
				break;
			case 'video':
				let videos = _.pullAllBy(aNewsVideos, [{ 'file_name': file_name }], 'file_name')
				this.setState({ aNewsVideos: videos, })
				break;
			default:
				break;
		}

		let dotIndex = file_name.lastIndexOf('.');
		let file_id = file_name.substring(dotIndex - 18, dotIndex);
		deleteFiles.push(file_id);
		this.setState({ deleteFiles: deleteFiles })

		// 原版點了直接刪除
		// const { newsId } = this.props.params

		// let type = 'News';
		// let dotIndex = file_name.lastIndexOf('.');
		// let file_id = '';

		// if( dotIndex!== -1 ){
		//     file_id = file_name.substring(dotIndex-18,dotIndex);//201702181504133927
		//     let formData = new FormData();
		//     formData.append('file_id', file_id);
		//     formData.append('type', type);

		//     $.ajax({
		//     		async: false,
		//         type: 'post',
		//         url: '/api/W_SaleSky_FileUpload_Delete.php',
		//         data: formData,
		//         processData: false,
		//         contentType: false,
		//         success: response => { },
		//         error: (xhr, ajaxOptions, thrownError) => { },
		//         complete: ()=> {
		//             this.loadOneNews(newsId);
		//         },
		//     });  
		// }
	}
	removeFiles() {

		const { deleteFiles } = this.state

		for (let i = 0; i < deleteFiles.length; i++) {

			let formData = new FormData();
			formData.append('file_id', deleteFiles[i]);
			formData.append('type', 'News');

			$.ajax({
				async: false,
				type: 'post',
				url: '/api/W_SaleSky_FileUpload_Delete.php',
				data: formData,
				processData: false,
				contentType: false,
				success: response => { },
				error: (xhr, ajaxOptions, thrownError) => { },
			});
		}
	}
	onClickDelete() {
		/*
		  目前此API尚未完成
		*/
		let id = this.state.aNewsId;
		let formData = new FormData();
		formData.append('news_id', id);
		if (confirm('確定刪除嗎?')) {

			$.ajax({
				type: 'post',
				url: '/api/W_SaleSky_News_Lang_Delete.php',
				data: formData,
				processData: false,
				contentType: false,
				success: response => {
					this.props.reloadDataList();//newsDataTable也要重刷頁面
					this.props.closeModal();
				},
				error: (xhr, ajaxOptions, thrownError) => { },
			});
		}
	}
	loadMultiSelectOptions() {

		const { userOptions, groupOptions } = this.state

		if (userOptions.length === 0 || groupOptions.length === 0) {
			axios.get('/api/M_SaleSky_Users.php').then(res => {
				let users = res.data.result;
				let userList = [];

				for (let i = 0; i < users.length; i++) {
					let aUser = { label: users[i].name, value: users[i].id }
					userList.push(aUser);
				}

				this.setState({ userOptions: userList });
			})

			axios.get('/api/M_SaleSky_UserGroup.php').then(res => {
				let groups = res.data.result;
				let groupList = [];

				for (let i = 0; i < groups.length; i++) {
					let aGroup = { label: groups[i].name, value: groups[i].id }
					groupList.push(aGroup);
				}

				this.setState({ groupOptions: groupList });
			})
		}
	}
	multiSelectChangeHandler(label, value) {
		/*
			複選選單的onChange事件function
			label: user/group
		*/
		if (label === 'user') {
			this.setState({ userSelectedValues: value });
		} else {
			this.setState({ groupSelectedValues: value });
		}
	}
	render() {
		let {
			closeModal,
			route
		} = this.props;
		let {
			aNewsId,
			aNewsTitle_tw,
			aNewsTitle_en,
			aNewsTitle_cn,
			aNewsTitle_ja,
			aNewsFlag,
			aNewsType_id,
			aNewsStart_time,
			aNewsEnd_time,
			aNewsMessage_tw,
			aNewsMessage_en,
			aNewsMessage_cn,
			aNewsMessage_ja,
			enableEdit,
			showErrorMsg,
			newsTypeArray,
			filesToUpload,
			aNewsImages,
			aNewsPDFs,
			aNewsVideos,
			fileUploading,
			all_policy,
			userOptions,
			userSelectedValues,
			groupOptions,
			groupSelectedValues
		} = this.state;

		// const 
		// aNewsTitle = {
		//     aNewsTitle_tw,
		//     aNewsTitle_en,
		//     aNewsTitle_cn,
		//     aNewsTitle_ja
		// },
		// aNewsMessage = {
		//     aNewsMessage_tw,
		//     aNewsMessage_en,
		//     aNewsMessage_cn,
		//     aNewsMessage_ja
		// };

		return (
			<div>
				<NewsModalPs
					closeModal={closeModal}//關閉Modal
					enableEdit={enableEdit}//是否為編輯模式
					aNewsId={aNewsId}
					aNewsTitle_tw={aNewsTitle_tw}
					aNewsTitle_en={aNewsTitle_en}
					aNewsTitle_cn={aNewsTitle_cn}
					aNewsTitle_ja={aNewsTitle_ja}
					// aNewsTitle={aNewsTitle}
					aNewsFlag={aNewsFlag}
					newsTypeArray={newsTypeArray}//類型
					aNewsType_id={aNewsType_id}
					aNewsStart_time={aNewsStart_time}
					aNewsEnd_time={aNewsEnd_time}
					aNewsMessage_tw={aNewsMessage_tw}
					aNewsMessage_en={aNewsMessage_en}
					aNewsMessage_cn={aNewsMessage_cn}
					aNewsMessage_ja={aNewsMessage_ja}
					// aNewsMessage={aNewsMessage}
					onChangeDate={this.onChangeDate}
					onChangeHandler={this.onChangeHandler}
					sendEdit={this.sendEdit}//點擊儲存的btn
					onClickEdit={this.onClickEdit}//點擊編輯的btn
					showErrorMsg={showErrorMsg}//是否顯示錯誤訊息
					pathname={this.props.location.pathname}//網址路徑
					onClickDelete={this.onClickDelete}//點擊刪除
					filesToUpload={filesToUpload}
					onDrop={this.onDrop}
					aNewsImages={aNewsImages}//圖片陣列
					aNewsPDFs={aNewsPDFs}//PDF陣列
					aNewsVideos={aNewsVideos}//影片陣列   
					fileDelete={this.fileDelete}//刪除檔案
					fileUploading={fileUploading}//是否正在上傳中
					all_policy={all_policy}
					userOptions={userOptions}
					userSelectedValues={userSelectedValues}
					groupOptions={groupOptions}
					groupSelectedValues={groupSelectedValues}
					multiSelectChangeHandler={this.multiSelectChangeHandler}
					onPreviewFileDelete={this.onPreviewFileDelete}
					route_type={route.type}
					onFocus={this.handlers.onInputFocus}
				/>
			</div>
		);
	}
}

NewsModalCt.prototypes = {
	closeModal: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/salesky/routes/news/NewsModalCt.jsx